// shippingApi.ts
import { http } from "./http";

/**
 * 
 * 🔹 Admin Shipping Rate APIs
 */

// GET all shipping rates per location
export const getShippingRates = async () => {
  try {
    const res = await http.get("/api/settings/shipping");
    return res.data;
  } catch (error) {
    console.error("❌ Failed to fetch shipping rates:", error);
    throw error;
  }
};

// UPDATE flat shipping rate for a location
export const updateShippingRate = async (
  locationId: number,
  flatRate: number,
  freeShippingMinimum: number,
  wholesaleFreeShippingMinimum?: number
) => {
  try {
    const res = await http.put(`/api/settings/shipping/${locationId}`, {
      flat_shipping_rate: flatRate,
      free_shipping_minimum: freeShippingMinimum,
      ...(wholesaleFreeShippingMinimum !== undefined
        ? { wholesale_free_shipping_minimum: wholesaleFreeShippingMinimum }
        : {}),
    });
    return res.data;
  } catch (error) {
    console.error("❌ Failed to update shipping rate:", error);
    throw error;
  }
};